import { CreditCardFilled, CreditCardOutlined, ExclamationCircleFilled, FilePdfFilled, FilePdfOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Form, Input, Modal, Select, Space, Spin, Table, Tag } from 'antd';
import frFR from "antd/locale/fr_FR";
import { createRef, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import Footer from '../../components/Footer';
import NavBar from '../../components/NavBar';
import SideBar from '../../components/SideBar';
import { frenchDate, frenchDateOnly } from '../../variables/functions';
import RecuDeVersementDePrimeEnCompagnie from '../production/components/docs/RecuDeVersementDePrimeEnCompagnie';
import axiosInstance from '../../variables/api/axiosInstance';
import { LOGGED_USER } from '../../variables/constants';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import BorderauReversementPrimes from './docs/BorderauReversementPrimes';
import { displayFloorNum, displayNum, displayNumbers } from '../../variables/numbersFunctions';
import { componentToBase64, imageToBase64 } from '../../variables/imagesFunctions';
import { DocumentFooter } from '../../components/docs/DocumentFooter';
import DocumentHeader from '../../components/docs/DocumentHeader';
const { confirm } = Modal;
const { Option } = Select;
const { Search } = Input;

const BorderauReversement = () => {
    const [datas, setDatas] = useState([]);
    const [allDatas, setAllDatas] = useState([]);
    const [dataSum, setDataSum] = useState(0);
    const [todayDatas, setTodayDatas] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [todayDataSum, setTodayDataSum] = useState(0);
    const [monthDatas, setMonthDatas] = useState([]);
    const [monthDataSum, setMonthDataSum] = useState(0);
    const [nonCashedDatas, setNonCashedDatas] = useState([]);
    const [nonCashedDataSum, setNonCashedDataSum] = useState(0);
    const [loadingData, setLoadingData] = useState(true);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [bordereauToPay, setBordereauToPay] = useState([]);
    const [numeroPaiement, setNumeroPaiement] = useState("P");
    const [modePaiement, setModePaiement] = useState("");
    const [modePaiementForm] = Form.useForm();
    const [banques, setBanques] = useState([]);
    const [banque, setBanque] = useState("BANQUE");
    const [hidden, setHidden] = useState(false);
    const [openModalBorderau, setOpenModalBorderau] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleChange = (pagination, filters, sorter) => {
        console.log("Various parameters", pagination, filters, sorter);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        console.log("SelectedRows", rows);
        setSelecting(true);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/bordereau`)
            .then((res) => {
                console.log(res.data);
                setAllDatas(res.data);
                setLoadingData(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingData(false);
            });

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const encaisserBordereau = (bd) => {
        setModalModePaiement(true);
        setBordereauToPay(bd);
    };

    const columns = [
        {
            title: "N° bordereau",
            dataIndex: "numeroBordereau",
            key: "numeroBordereau",
        },
        {
            title: "Apporteur",
            dataIndex: "agence",
            key: "agence",
            render: (_, record) => (
                <>{record.agence?.nom}</>
            )
        },
        {
            title: "Montant",
            dataIndex: "montant",
            key: "montant",
            render: (_, record) => (
                <>{displayNumbers(record.montantTotal)} </>
            ),
        },
        {
            title: "Mode de paiement",
            dataIndex: "modePaiement",
            key: "modePaiement",
            render: (_, record) => (
                <>{record.modePaiement === "ESPECES" ? <Tag color='blue'>ESPECES</Tag> : record.modePaiement === "RISTOURNE" ? <Tag color='green'>RISTOURNE</Tag> : record.modePaiement && record.modePaiement !== "-" ? <Tag color='yellow'>{record.modePaiement}</Tag> : null} </>
            ),
            // filters: [
            //     {
            //         text: "ESPECES",
            //         value: "ESPECE",
            //     },
            //     {
            //         text: "RISTOURNE",
            //         value: "RISTOURNE",
            //     },
            //     {
            //         text: "BANQUE",
            //         value: "BANQUE",
            //     },
            //     {
            //         text: "MOBILE MONEY",
            //         value: "MOBILE_MONEY",
            //     },
            //     {
            //         text: "COMPENSATION",
            //         value: "COMPENSATION",
            //     },
            //     {
            //         text: "NON PAYE",
            //         value: "-",
            //     },
            // ],
            // filteredValue: filteredInfo.modePaiement || null,
            // onFilter: (value, record) => record.modePaiement === value,
            // sorter: (a, b) => a.modePaiement.length - b.modePaiement.length,
            // sortOrder: sortedInfo.columnKey === "modePaiement" ? sortedInfo.order : null,
            // ellipsis: true,
        },
        {
            title: "Date édition",
            dataIndex: "dateReglement",
            key: "dateReglement",
            render: (_, record) => (
                <>{record.createdAt ? frenchDate(record.createdAt) : "-"} </>
            ),
        },
        {
            title: "Date versement",
            dataIndex: "dateVersementCompagnie",
            key: "dateVersementCompagnie",
            render: (_, record) => (
                <>{frenchDate(record.dateReglement)} </>
            ),
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_, record) => (
                <Space size="middle">
                    <Button style={{ background: "purple", color: "white" }} icon={<FilePdfOutlined />} onClick={() => genererBorderau(record)} />

                    {!record?.modePaiement && LOGGED_USER?.agence?.typeAgence === "SIEGE" ?
                        <Button style={{ background: "gold", color: "white" }} icon={<CreditCardOutlined />} onClick={() => encaisserBordereau(record)} /> : null
                    }
                </Space>
            )
        }
    ];

    const genererBorderau = (bord) => {
        if (bord?.reglements.length > 0) {
            setBordereauToPay(bord);
            // console.log("Rows selected", bord);
            setOpenModalBorderau(true);
        } else {
            toast("Veuillez choisir un bordereau avec des reglements");
        }
    };

    const alertReglementBordereau = (bd) => {
        confirm({
            title: "Etes-vous sûr de vouloir régler ce bordereau?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementBordereau(bd);
            },
            onCancel() {
                console.log("Cancel");
            },
        });


    };

    const reglementBordereau = (bd) => {
        axiosInstance
            .put(`/api/bordereau/encaisser`, {
                codeId: bd.codeId,
                modePaiement: modePaiement,
                numeroPaiement: numeroPaiement,
                banque: banque
            })
            .then((resp) => {
                toast("Reglement effectué avec succès!");
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors du règlement");
            });

    };

    const apporteurFiltering = (e) => {
        // console.log("Apporteur: ", e.target.value);
        const value = e.target.value;
        if (value?.trim()) {
            let filRegs = [];
            filRegs = allDatas.filter((dt) => (dt?.contrat?.intermediaire !== null && dt?.contrat?.intermediaire?.personne?.nom?.trim().toLowerCase().startsWith(value.trim().toLowerCase())) ||
                (dt?.contrat?.intermediaire !== null && dt?.contrat?.intermediaire?.personne?.prenom != null && dt.contrat.intermediaire?.personne?.prenom.trim().toLowerCase().startsWith(value.trim().toLowerCase())) ||
                (dt?.contrat?.intermediaire !== null && dt?.contrat?.intermediaire?.codeIntermediaire?.trim().toLowerCase().startsWith(value.trim().toLowerCase())) ||
                (dt?.contrat?.courtier !== null && dt?.contrat?.courtier?.nom?.trim().toLowerCase().startsWith(value.trim().toLowerCase())) ||
                (dt?.contrat?.courtier !== null && dt?.contrat?.courtier?.codeAgence?.trim().toLowerCase().startsWith(value.trim().toLowerCase())));
            // allDatas.forEach(dt => {
            //     dt.contrat.intermediaire !== null && dt.contrat.intermediaire.personne.nom.trim().toLowerCase().startsWith(value.trim().toLowerCase()) && filRegs.push(dt);
            // });
            setDatas(filRegs);
        } else {
            setDatas(allDatas);
        }

    }

    const encaisserVersements = (cts) => {
        console.log(cts);
        if (cts.length) {
            setModalModePaiement(true);
            setBordereauToPay(cts);
        } else {
            toast("Aucun règlement sélectionné!");
        }
    };


    const printRecu = createRef();

    const exportRecuToPdf = () => {
        handleRecu();
    };

    const handleRecu = useReactToPrint({
        content: () => printRecu.current,
    });


    const calculateTotals = (reglements) => {
        return reglements.reduce((acc, reg) => ({
            montant: acc.montant + (reg.montant || 0),
            primeNetteCompagnie: acc.primeNetteCompagnie + (reg.primeNetteCompagnie || 0),
            accessoires: acc.accessoires + (reg.accessoires || 0),
            taxes: acc.taxes + (reg.taxes || 0),
            primeTotale: acc.montant + (reg.montant || 0),
            commissions: acc.commissions + (reg.commissions || 0)
        }), {
            montant: 0,
            primeNetteCompagnie: 0,
            accessoires: 0,
            taxes: 0,
            primeTotale: 0,
            commissions: 0
        });
    };

    const generatePDF = async (data) => {
        setLoading(true);

        try {

            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const totals = calculateTotals(data?.reglements);

            // Convertir l'entête en base64
            let headerBase64 = null;
            if (DocumentHeader) {
                headerBase64 = await componentToBase64(<DocumentHeader logoPreviewUrl={`data:image/png;base64,${bordereauToPay?.logoDisplay}`} />);
            }

            // Convertir le footer en base64
            let footerBase64 = null;
            if (DocumentFooter) {
                footerBase64 = await componentToBase64(<DocumentFooter />);
            }

            // Fonction pour ajouter header et footer sur chaque page
            const addHeaderFooter = (pageNumber) => {
                // Ajouter l'entête
                if (headerBase64) {
                    const headerHeight = 25; // Hauteur de l'entête en mm
                    doc.addImage(headerBase64, 'PNG', 0, 0, pageWidth, headerHeight);
                }

                // Ajouter le footer
                if (footerBase64) {
                    const footerHeight = 20; // Hauteur du footer en mm
                    const footerY = pageHeight - footerHeight;
                    doc.addImage(footerBase64, 'PNG', 0, footerY, pageWidth, footerHeight);
                }

                // Numéro de page
                doc.setFontSize(8);
                doc.setTextColor(128);
                doc.text(
                    `Page ${pageNumber}`,
                    pageWidth - 20,
                    pageHeight - 5,
                    { align: 'right' }
                );
            };

            // Ajouter header sur la première page
            addHeaderFooter(1);

            // Position de départ du contenu (après l'entête)
            const startY = headerBase64 ? 30 : 15;

            // Titre
            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            const title = `BORDEREAU DE REVERSEMENT DE PRIMES N° ${data?.numeroBordereau}`;
            const titleWidth = doc.getTextWidth(title);
            doc.text(title, (pageWidth - titleWidth) / 2, startY);

            // Préparation des données du tableau
            const tableData = data?.reglements.map(reg => [
                reg.contrat?.numeroPoliceP || '',
                reg.avenantCode || '',
                reg?.contrat?.souscripteur?.nom + ' ' + (reg?.contrat?.souscripteur?.prenom || '') || '',
                frenchDateOnly(reg.contrat?.dateEffet) || '',
                frenchDateOnly(reg.contrat?.dateEcheance) || '',
                reg.contrat?.categorie || '',
                displayFloorNum(reg.montant),
                displayFloorNum(reg.primeNetteCompagnie),
                displayFloorNum(reg.accessoires),
                displayFloorNum(reg.taxes),
                displayFloorNum(reg.montant),
                reg.tauxCommission ? `${reg.tauxCommission}%` : '',
                displayFloorNum(reg.commissions || 0)
            ]);

            // Ligne des totaux
            tableData.push([
                { content: 'Totaux', colSpan: 6, styles: { fontStyle: 'bold', halign: 'center' } },
                { content: displayFloorNum(totals.montant), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.primeNetteCompagnie), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.accessoires), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.taxes), styles: { fontStyle: 'bold' } },
                { content: displayFloorNum(totals.montant), styles: { fontStyle: 'bold' } },
                '',
                { content: displayFloorNum(totals.commissions), styles: { fontStyle: 'bold' } }
            ]);
            // Calcul de la marge basse (pour le footer)
            const bottomMargin = footerBase64 ? 25 : 10;
            // Génération du tableau
            autoTable(doc, {
                startY: startY + 5,
                head: [[
                    'N° Police',
                    'Avenant',
                    'Assuré',
                    'Effet',
                    'Échéance',
                    'Catégorie',
                    'PN Pool',
                    'PN Compagnie',
                    'CP',
                    'Taxes',
                    'PT TC',
                    'Taux commissions',
                    'Commissions'
                ]],
                body: tableData,
                theme: 'striped',
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                    halign: 'center',
                    valign: 'middle'
                },
                headStyles: {
                    fillColor: [41, 128, 185],
                    textColor: 255,
                    fontStyle: 'bold',
                    halign: 'center',
                    fontSize: 7
                },
                columnStyles: {
                    0: { cellWidth: 30 }, // N° Police
                    1: { cellWidth: 15 }, // Avenant
                    2: { cellWidth: 35, halign: 'left' }, // Assuré
                    3: { cellWidth: 20 }, // Effet
                    4: { cellWidth: 20 }, // Échéance
                    5: { cellWidth: 18 }, // Catégorie
                    6: { cellWidth: 20, halign: 'right' }, // PN Pool
                    7: { cellWidth: 20, halign: 'right' }, // PN Compagnie
                    8: { cellWidth: 20, halign: 'right' }, // CP
                    9: { cellWidth: 18, halign: 'right' }, // Taxes
                    10: { cellWidth: 20, halign: 'right' }, // PT TC
                    11: { cellWidth: 15 }, // Taux
                    12: { cellWidth: 18, halign: 'right' } // Commissions
                },
                didParseCell: function (data) {
                    // Style pour la ligne des totaux
                    if (data.row.index === tableData.length - 1) {
                        data.cell.styles.fillColor = [236, 240, 241];
                        data.cell.styles.fontStyle = 'bold';
                    }
                },
                margin: { left: 10, right: 10 },
                didDrawPage: function (data) {
                    // Ajouter header et footer sur chaque nouvelle page
                    if (data.pageNumber > 1) {
                        addHeaderFooter(data.pageNumber);
                    }
                }
            });

            // Pied de page avec signatures
            const finalY = doc.lastAutoTable.finalY + 10;

            // Vérifier s'il y a assez d'espace pour les signatures
            if (finalY + 25 < pageHeight - bottomMargin) {
                doc.setFontSize(10);
                doc.setFont(undefined, 'bold');
                doc.setTextColor(0);

                const signatureY = finalY;
                const signatureLineY = signatureY + 15;

                // Le Courtier
                doc.text('L\'agent', 30, signatureY);
                doc.line(20, signatureLineY, 80, signatureLineY);

                // Le Gestionnaire
                // doc.text('Le Gestionnaire', pageWidth / 2 - 20, signatureY);
                // doc.line(pageWidth / 2 - 30, signatureLineY, pageWidth / 2 + 30, signatureLineY);

                // La Compagnie
                doc.text('La Compagnie', pageWidth - 50, signatureY);
                doc.line(pageWidth - 60, signatureLineY, pageWidth - 20, signatureLineY);
            }

            window.open(doc.output('bloburl'), '_blank');

        } catch (error) {
            console.error('Erreur lors de la génération du PDF:', error);
            alert('Erreur lors de la génération du PDF');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"CAISSE"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <div class="row g-6 mb-6">
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">Versements à effectuer en compagnie</span>
                                                    <div class="d-flex align-items-center my-1">
                                                        <h5 class="mb-0 me-2">{todayDatas?.length} ({displayNumbers(
                                                            Math.trunc(todayDataSum)
                                                        )} FCFA)</h5>
                                                        {/* <p class="text-success mb-0">(+29%)</p> */}
                                                    </div>
                                                    <small class="mb-0">du jour</small>
                                                </div>
                                                <div class="avatar">
                                                    <span class="avatar-initial rounded bg-label-primary">
                                                        <i class="bx bx-group bx-lg"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">Versements à effectuer en compagnie</span>
                                                    <div class="d-flex align-items-center my-1">
                                                        <h5 class="mb-0 me-2">{monthDatas?.length} ({displayNumbers(
                                                            Math.trunc(monthDataSum)
                                                        )} FCFA)</h5>
                                                        {/* <p class="text-success mb-0">(+18%)</p> */}
                                                    </div>
                                                    <small class="mb-0">
                                                        du mois
                                                    </small>
                                                </div>
                                                <div class="avatar">
                                                    <span class="avatar-initial rounded bg-label-danger">
                                                        <i class="bx bx-user-plus bx-lg"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">Versements à effectuer en compagnie</span>
                                                    <div class="d-flex align-items-center my-1">
                                                        <h5 class="mb-0 me-2">{datas?.length} ({displayNumbers(
                                                            Math.trunc(dataSum)
                                                        )} FCFA)</h5>
                                                        {/* <p class="text-danger mb-0">(-14%)</p> */}
                                                    </div>
                                                    <small class="mb-0">
                                                        total
                                                    </small>
                                                </div>
                                                <div class="avatar">
                                                    <span class="avatar-initial rounded bg-label-success">
                                                        <i class="bx bx-user-check bx-lg"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-xl-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="d-flex align-items-start justify-content-between">
                                                <div class="content-left">
                                                    <span class="text-heading">Non encaissés</span>
                                                    <div class="d-flex align-items-center my-1">
                                                        <h5 class="mb-0 me-2">{nonCashedDatas?.length} ({displayNumbers(
                                                            Math.trunc(nonCashedDataSum)
                                                        )} FCFA)</h5>
                                                        {/* <p class="text-success mb-0">(+42%)</p> */}
                                                    </div>
                                                    <small class="mb-0">
                                                        Total
                                                    </small>
                                                </div>
                                                <div class="avatar">
                                                    <span class="avatar-initial rounded bg-label-warning">
                                                        <i class="bx bx-user-voice bx-lg"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                {LOGGED_USER?.agence?.typeAgence === "SIEGE" ?
                                    <div class="container">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <Search
                                                            placeholder="Rechercher par rapport à l'apporteur..."
                                                            onSearch={(value) => {
                                                                apporteurFiltering(value);
                                                            }}
                                                            onChange={(value) => apporteurFiltering(value)}
                                                            style={{ width: "100%" }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null}
                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingData}>
                                        <Table
                                            rowSelection={rowSelection}
                                            columns={columns}
                                            dataSource={allDatas}
                                            onChange={handleChange}
                                            rowKey={"codeId"}
                                        // footer={() => <MyFooter />}
                                        />
                                    </Spin>
                                </ConfigProvider>
                            </div>
                            {hidden ? (
                                <div className="container">
                                    <div className="excel-table-wrapper">
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "135vh", margin: 0, padding: 0 }}>
                                            <RecuDeVersementDePrimeEnCompagnie
                                                ref={printRecu}
                                                contrats={selectedRows}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            <Modal
                title="Bordereau de versement de primes"
                centered
                open={openModalBorderau}
                onOk={() => {
                    console.log("OK");
                }}
                onCancel={() => {
                    setOpenModalBorderau(false);
                }}
                width={1300}
                zIndex={2000}
            >
                <div className="bordereau-container print-document print-landscape">
                    <div className="header-content">
                        <DocumentHeader logoPreviewUrl={`data:image/png;base64,${bordereauToPay?.logoDisplay}`} />
                        <div className="document-title">
                            <h5><u>Bordereau de reversement N° {bordereauToPay?.numeroBordereau}</u></h5>
                        </div>
                    </div>
                    <BorderauReversementPrimes
                        bordereau={bordereauToPay}
                    />
                    <DocumentFooter />
                </div>
                <Button
                    type="primary"
                    onClick={() => {
                        generatePDF(bordereauToPay);
                    }}
                    icon={<FilePdfOutlined />}
                    style={{ marginTop: "50px", backgroundColor: "gray" }}
                >
                    Imprimer
                </Button>

            </Modal>
            <Modal
                title="Mode de paiement"
                centered
                open={modalModePaiement}
                onOk={() => {
                    alertReglementBordereau(bordereauToPay);
                }}
                onCancel={() => {
                    setModalModePaiement(false);
                }}
            >
                <>
                    <div className="container" justify="center">
                        <div className="grid-item" lg={12}>
                            <Form
                                form={modePaiementForm}
                                layout="vertical"
                                name="userForm"
                            >
                                <Form.Item
                                    name="modePaiement"
                                    label="Mode de paiement"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        onChange={(value) => {
                                            console.log(value);
                                            setModePaiement(value);
                                        }}
                                        placeholder="Selectionnez votre mode de paiement"
                                    >
                                        <Option value="ESPECES"> ESPECES </Option>
                                        <Option value="BANQUE">BANQUE (Chèque)</Option>
                                        <Option value="MOBILE_MONEY">TMONEY / FLOOZ</Option>
                                    </Select>
                                </Form.Item>
                                {modePaiement === "BANQUE" ||
                                    modePaiement === "MOBILE_MONEY" ? (
                                    <Form.Item
                                        name="numeroPaiement"
                                        label={
                                            modePaiement === "BANQUE"
                                                ? "Numero de chèque"
                                                : modePaiement === "MOBILE_MONEY"
                                                    ? "Numero FLOOZ / TMONEY"
                                                    : ""
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message: "Veuillez renseigner le champ!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={
                                                modePaiement === "BANQUE"
                                                    ? "Le numero de chèque"
                                                    : modePaiement === "MOBILE_MONEY"
                                                        ? "Le numero de téléphone MOOV (FLOOZ) / TOGOCOM (TMONEY)"
                                                        : ""
                                            }
                                            onChange={(value) => {
                                                console.log(value.target.value);
                                                setNumeroPaiement(value.target.value);
                                            }}
                                        />
                                    </Form.Item>
                                ) : null}
                                {modePaiement === "BANQUE" ? (
                                    <Form.Item
                                        name="banque"
                                        label="Banque"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Select
                                            onChange={(value) => {
                                                console.log(value);
                                                setBanque(value);
                                            }}
                                            placeholder="Selectionnez la banque"
                                        >
                                            {banques.map((b) => (
                                                <Option
                                                    key={b.parametreId}
                                                    value={b.libelleParametre}
                                                >
                                                    {b.libelleParametre}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                ) : null}
                            </Form>
                        </div>
                    </div>
                </>
            </Modal>
            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
}

export default BorderauReversement